<p-accordionTab [selected]="selected">
    <ng-template pTemplate="header">
        <sms-heading class="relative">
            {{ header }}
            <p-badge class="ml-2" *ngIf="count" [value]="count" severity="danger"></p-badge>
        </sms-heading>
    </ng-template>
    <ng-content></ng-content>
</p-accordionTab>
